module.exports = __webpack_public_path__ + "static/aptos-132fe5902e9d0f61c23b986212bff5be.jpg";